import React from "react";
import "./LoadingSpinner.css";

/**
 * Indicador de carregamento: anel animado (CSS, sem GIF).
 * Em navegadores recentes usa gradiente cônico; caso contrário, borda rotacionada.
 */
export default function LoadingSpinner({
  size = 48,
  className = "",
  onDark = false,
  label = "Carregando",
  /** Quando true, o anel é só decoração (mensagem vem de outro elemento) */
  decorative = false,
}) {
  return (
    <div
      className={`loading-spinner ${onDark ? "loading-spinner--on-dark" : ""} ${className}`.trim()}
      style={{ width: size, height: size }}
      role={decorative ? undefined : "status"}
      aria-hidden={decorative ? "true" : undefined}
      aria-live={decorative ? undefined : "polite"}
      aria-busy={decorative ? undefined : "true"}
      aria-label={decorative ? undefined : label}
    >
      <div className="loading-spinner__track" aria-hidden />
    </div>
  );
}

/** Bloco centralizado (ex.: área principal da página) */
export function LoadingSpinnerBlock({
  size = 56,
  hint,
  className = "",
  padding = "40px",
}) {
  return (
    <div
      className={`loading-spinner-block ${className}`.trim()}
      style={{ padding }}
      role="status"
      aria-live="polite"
      aria-busy="true"
    >
      <LoadingSpinner size={size} decorative={Boolean(hint)} label={hint || "Carregando"} />
      {hint ? (
        <p className="loading-spinner-block__hint">{hint}</p>
      ) : (
        <span className="sr-only">Carregando</span>
      )}
    </div>
  );
}
